import { render } from "preact";
import { App } from "./app";
import { ErrorBoundary } from "./ErrorBoundary";
import { initAnalytics } from "./lib/analytics";
import { installGlobalErrorHandlers } from "./lib/errors";
import { PlacementDemo } from "./steps/PlacementDemo";
import "./styles.css";

// Kick off GA4 (page_view / session_start via enhanced measurement). No-ops in
// dev and in any build without a measurement id; never blocks first paint.
void initAnalytics();

// Catch uncaught errors and unhandled promise rejections and report them to GA4
// as `exception` events (#18). PII-safe; never throws.
installGlobalErrorHandlers();

// Wrap the funnel so a render crash reports to GA4 and falls back to a contact
// screen instead of a white page.
const showPlacementDemo = new URLSearchParams(window.location.search).has("placement");

render(
  showPlacementDemo ? (
    <PlacementDemo />
  ) : (
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  ),
  document.getElementById("app")!,
);
